<footer class="relative p-4 pt-12 md:p-8">
  <app-technical-support></app-technical-support>
</footer>
